import { render, staticRenderFns } from "./FreightItemModal.vue?vue&type=template&id=56eee05c&scoped=true&"
import script from "./FreightItemModal.vue?vue&type=script&lang=js&"
export * from "./FreightItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56eee05c",
  null
  
)

export default component.exports